// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function scannersMenu_mouseIn(event) {
	//Add your code for this event here: 
}

export function scannersMenu_mouseOut(event) {
	//Add your code for this event here: 
}